import { Component, OnInit } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../store/app.store';
import { selectMenuList } from '../../../../store/MenuList/menu.selectors';
import { TreeNode } from 'primeng/api';
import { AdministratorService } from '../../../../services/administrator.service';
import { gridPageRequest } from '../../../../model/common/common.model';

@Component({
  selector: 'app-menu-list',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './menu-list.component.html',
  styleUrl: './menu-list.component.scss'
})
export class MenuListComponent implements OnInit {
dt1: any;

  constructor(private route: Router, private store: Store<AppState>, private administratorService:AdministratorService) {}

  menuList: any[] = [];
  selectedMenu: any;
  files!: TreeNode[];
  searchKey : any;

  ngOnInit(): void {
    document.title = 'Menu List';
    this.getMenuList();
    this.searchEffect();
  }
 pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 50,
    id: 0
  }

  deleteMenu() {
    console.log(this.selectedMenu[0]);
  }

  editMenu() {
    console.log(this.selectedMenu[0]);
  }

  CreateMenu() {
    this.route.navigate(['/home/createMenu']);
  }

  getMenuList() {
    // this.store.select(selectMenuList).subscribe((menuList) => {
    //   this.menuList = menuList;
    //   this.files = this.transformData(menuList);
    // });
    this.administratorService.GetAllMenu().subscribe(
      (data: any) => {
        if (data) {
          // console.log(data);
          this.files = this.transformData(data);
          // console.log(this.files);
        } else {
          console.log(data);
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }




  transformData(originalData: any[]): TreeNode[] {
    return originalData.map(item => {
      const transformedItem: TreeNode = {
        data: { menu: item.name, submenu: '' , menuid: item.menuId },
        children: item.subMenu ? this.transformSubmenu(item.subMenu) : undefined
      };
      return transformedItem;
    });
  }

  transformSubmenu(originalData: any[]): TreeNode[] {
    return originalData.map(item => {
      const transformedItem: TreeNode = {
        data: { sub: item.name, submenu: item.name },
      };
      return transformedItem;
    });
  }

  searchMenu() {
    if (!this.searchKey) {
      return;
    }
    this.administratorService.autoSearchMenu(this.searchKey).subscribe(
      (data: any) => {
        if (data) {
          // Ensure the data is transformed to TreeNode[] format before assigning
          this.files = this.transformData(data);
          if (this.dt1) {
            this.dt1.first = 0;  // Reset pagination
          }
        } else {
          console.log('No data found');
        }
      },
      (error: any) => {
        console.log(error);  
      }
    );
  }
  


refreshData(): void {
  if (this.dt1) {
    this.dt1.first = 0; 
    this.dt1.clear();
  }
  this.searchKey = ''; 
  this.pageRequest.pageIndex = 0;
  this.pageRequest.pageSize = 50; 
  this.getMenuList(); 
}
loadMenu(event:any){
  if (this.searchKey && this.searchKey.trim() !== '') {
    this.searchMenu();
  } else {
    this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
    this.getMenuList();
  }
}

  placeholder: string = 'Search By ';
  private messages: string[] = ['Menu', 'Menu Id'];
  private messageIndex = 0;
  private charIndex = 0;


  searchEffect() {
    const base = 'Search By ';
    const typeNextChar = () => {
      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };
    typeNextChar();
  }
}
